import { render, staticRenderFns } from "./EcClass.vue?vue&type=template&id=d0ed3bfc&scoped=true&"
import script from "./EcClass.vue?vue&type=script&lang=js&"
export * from "./EcClass.vue?vue&type=script&lang=js&"
import style0 from "./EcClass.vue?vue&type=style&index=0&id=d0ed3bfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ed3bfc",
  null
  
)

export default component.exports